// @flow

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getTranslate } from 'react-localize-redux';
import moment from 'moment';
import { createReminders, updateReminders } from 'actions/reminder/reminder';
import Companies from 'components/main/InsuranceInquiry/reminder/companies';
import Sent from 'components/main/InsuranceInquiry/reminder/sent';
import ToEarly from 'components/main/InsuranceInquiry/reminder/toEarly';
import Sending from 'components/main/InsuranceInquiry/reminder/sending';
import SentAllReminders from 'components/main/InsuranceInquiry/reminder/sentAllReminders';
import ReminderView from 'components/main/InsuranceInquiry/reminder/index';

class Reminder extends Component {

  state: {
    selectedApp: Array<Number>;
    hasSendedReminders: boolean;
    isProcessing: boolean;
    processed: boolean;
  };

  constructor() {
    super();
    this.state = {
      selectedApp: [],
      hasSendedReminders: true,
      isProcessing: false,
      processed: false
    };

    this._setSelectedApp = this._setSelectedApp.bind(this);
    this._createReminder = this._createReminder.bind(this);
  }

  _setSelectedApp = (apps) => {
    this.setState({ selectedApp: apps });
  }

  _sendAllReminders() {
    const { currentApp } = this.props;
    if (!currentApp) { return };

    let sendAllReminders = true;
    currentApp.app_companies.map(item => {
      if (item.reminder_ws && item.reminder_ws.count < 2 && !item.reminder_ws.hidden) {
        sendAllReminders = false;
      };
      return true;
    });

    return sendAllReminders;
  }

  _willAbleToSend(d) {
    let date = moment(d)
    if ([4, 5, 6, 7].indexOf(date.day()) !== -1) {
      return date.add(4, 'days');
    } else {
      return date.add(3, 'days');
    }
  }

  _selectComponent() {
    const { currentApp, translate } = this.props;

    let ableToSend = this._willAbleToSend(currentApp.created_at);
    let component;

    if (this.state.isProcessing) {
      component = <Sending translate={translate} />;
    } else if (this._sendAllReminders()) {
      component = <SentAllReminders translate={translate} />
    } else if (this.state.processed) {
      component = <Sent translate={translate} />;
    } else {
      if (ableToSend.unix() > moment().unix()) {
        component = <ToEarly translate={translate} currentApp={currentApp} ableToSendDate={ableToSend} />
      } else {
        component = <Companies
          currentApp={currentApp}
          translate={translate}
          selectedApp={this.state.selectedApp}
          _setSelectedApp={this._setSelectedApp}
          _createReminder={this._createReminder}
          hasOutOfLimit={this._hasOutOfLimit()}
        />
      }
    }

    return (
      <div>{component}</div>
    )
  }

  _hasOutOfLimit() {
    const { currentApp } = this.props;
    if (!currentApp) { return };
    let active = currentApp.app_companies.find(item => {
      return item.reminder_ws.count >= 2;
    });

    return !!active;

  }

  dropProcessed() {
    this.setState({ isProcessing: false, processed: false, selectedApp: [] });
  }

  _createReminder = () => {
    if (!this.state.selectedApp || !this.state.selectedApp.length) { return null; };
    this.props.onCreate(this.state.selectedApp).then(res => {
      this.props.onUpdate(this.state.selectedApp);
      setTimeout(() => {
        this.setState({ isProcessing: false, processed: true });
      }, 2000);
    });
    this.setState({ isProcessing: true });
  }

  render() {
    const { translate, currentApp, variant } = this.props;
    if (!currentApp) { return null };
    let ableToSend = this._willAbleToSend(currentApp.created_at);

    return (
      <ReminderView
        translate={translate}
        shake={ableToSend.unix() < moment().unix()}
        dropProcessed={this.dropProcessed.bind(this)}
        component={this._selectComponent()}
        variant={variant}
        orderId={currentApp.order_id}
      />
    );
  }
}

const mapDispatchToProps = ({
  onCreate: createReminders,
  onUpdate: updateReminders
})

const mapStateToProps = state => ({
  translate: getTranslate(state.locale),
  currentApp: state.application.activeApplication,
});

export default connect(mapStateToProps, mapDispatchToProps)(Reminder);



// WEBPACK FOOTER //
// ./src/containers/insuranceInquiry/reminder.js